// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".spb-header {\n  background-size: cover;\n  height: 180px;\n}\n\n.header {\n  z-index: 1000;\n}", ""]);
// Exports
module.exports = exports;
